<template>
<div class="chapter">
<div class="inner_page">
<p class="pl-title"><a id="page3"></a>Emerald<br/>Mistress</p>
<p class="pl-author">Lynne<br/>Graham</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?1bba4833